
import { defineComponent, Ref, ref, watchEffect } from "vue";
import { getCarSizes } from "@/services/CostsCalculatorService";
import { CarSize } from "@/interfaces/CarSize";
import { OwnCarType } from "@/interfaces/OwnCarType";
import { ContentLoader } from "vue-content-loader";
import { getCarSizeTranslation } from "@/i18n";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "OwnCarType",
  props: {
    ownCarType: {
      type: Object as () => OwnCarType,
      default: null,
    },
  },
  components: { ContentLoader },
  emits: ["changeOwnCarType"],
  setup(props, { emit }) {
    const translation = useI18n();
    const error: Ref<boolean> = ref(false);
    const message: Ref<string> = ref("");
    const loading: Ref<boolean> = ref(false);
    const carSizes: Ref<CarSize[]> = ref([]);
    const selectedOwnCarType: Ref<OwnCarType> = ref(
      props.ownCarType ||
        ({
          isElectric: false,
        } as OwnCarType)
    );

    watchEffect(() => {
      emit("changeOwnCarType", selectedOwnCarType.value);
    });

    function initialize() {
      loading.value = true;
      getCarSizes("nl")
        .then((response) => {
          if (response.status == 200) {
            carSizes.value = response.data;
          } else {
            error.value = true;
          }
          loading.value = false;
        })
        .catch((ex) => {
          error.value = true;
          if (ex?.status === 404) {
            message.value = translation.t("error-no-carsizes-found");
          } else {
            message.value = ex.response;
          }
          loading.value = false;
        });
    }

    initialize();

    return {
      loading,
      error,
      message,
      carSizes,
      selectedOwnCarType,
      getCarSizeTranslation,
    };
  },
});
